import {useState} from 'react';
import {styled} from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import makeStyles from '@mui/styles/makeStyles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Grid} from '@mui/material';

import styles from 'assets/jss/user-info-style';

const useStyles = makeStyles(styles);

// *************** accordion styles *******************

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({theme}) => ({
  margin: '0 0 0',
  borderRadius: '16px',
  overflow: 'hidden',
  boxShadow:
    '-10px -10px 20px #FFFFFF, 10px 10px 10px rgba(174, 174, 192, 0.2)',
  border: '1px solid #FFFFFF',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon sx={{fontSize: '1.3rem', color: '#707070'}} />}
    {...props}
  />
))(({theme}) => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
  margin: 0,
  padding: 0,
}));

export const MainAccordion = (props) => {
  const classes = useStyles();
  const {open, header, subHeaderHypo, children} = props || {};
  const [expanded, setExpanded] = useState(open);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <Accordion
      sx={{
        background: expanded === 'panel1' ? '#F4F4F4' : '#EEEEEE',
      }}
      expanded={expanded === 'panel1'}
      onChange={handleChange('panel1')}>
      <AccordionSummary
        aria-controls='panel1d-content'
        id='panel1d-header'
        expandIcon={expanded === 'panel1' ? <RemoveIcon /> : <AddIcon />}>
        <Grid container>
          <Grid xs={12} item className={classes.centerContainer}>
            <span className={classes.mainAccHeader}>{header}</span>
          </Grid>
          <Grid
            xs={12}
            item
            className={classes.centerContainer}
            mt={typeof subHeaderHypo !== 'number' && '10px'}>
            {subHeaderHypo && (
              <span
                className={classes.subAccHeader}
                style={{textAlign: 'center', width: '100%', fontSize: '13px'}}>
                Analysing Readings {typeof subHeaderHypo == 'number' && 'From'}
                <span
                  className={classes.subAccHeaderRed}
                  style={{
                    fontSize: '13px',
                  }}>
                  {' '}
                  {subHeaderHypo}{' '}
                  {typeof subHeaderHypo == 'number' && 'days ago'}
                </span>
              </span>
            )}
          </Grid>
        </Grid>
      </AccordionSummary>
      <div
        style={{
          margin: 'auto',
          width: '70%',
          height: '1.5px',
          background: '#F9FAFB',
          boxShadow:
            '-0.2px -0.5px 1px #FFFFFF, 0.5px 0.75px 1px rgba(174, 174, 192, 0.6)',
        }}
      />
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
